import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { SupportedLang, useTranslation } from 'app/lang';

import mainHubInstance from '../hub/main-hub';
import { selectSignalrConnected } from '../redux/selectors';

const useLanguageSender = () => {
  const { lang } = useTranslation();
  const signalrConnected = useSelector(selectSignalrConnected);

  useEffect(() => {
    if (signalrConnected) {
      setSignalrLanguage(lang);
    }
  }, [signalrConnected, lang]);

  async function setSignalrLanguage(lang: SupportedLang) {
    const hubInstance = mainHubInstance.tryToGetHub();
    try {
      await hubInstance.send('setLanguage', lang);
    }
    catch (e) {
      console.error(`lib -> signalr -> hooks -> use-language-sender -> can't set language ${lang}`, e);
    }
  }
};

export default useLanguageSender;
